/* src/app/@framework/components/MenuControl/MenuControl.component.less */
zapp-menu .sidebar-container {
  height: 100%;
}
/*# sourceMappingURL=MenuControl.component.css.map */
